export const USER_ROLES = {
    ADMIN: "admin",
    OWNER: "owner",
    MANAGER: "manager",
    EMPLOYEE: "employee"
}

export const AUTH_PAGES = ["/landingpage", "/setPassword/:token", "/login", "/forgotPassword", "/register", "/createUserCompany", "/verifyEmail", "/emailVerification"];